import { render, staticRenderFns } from "./CustomDropdownFilter.vue?vue&type=template&id=5f6643fd"
import script from "./CustomDropdownFilter.vue?vue&type=script&lang=js"
export * from "./CustomDropdownFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomDropdownFilter.vue?vue&type=style&index=0&id=5f6643fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports